<p>label-print-dialog works!</p>
